import { render, staticRenderFns } from "./CustomLimitsPopup.vue?vue&type=template&id=32bce066"
import script from "./CustomLimitsPopup.vue?vue&type=script&lang=js"
export * from "./CustomLimitsPopup.vue?vue&type=script&lang=js"
import style0 from "./CustomLimitsPopup.vue?vue&type=style&index=0&id=32bce066&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports